export default __webpack_public_path__ + "static/media/logo-white.cac2fb18.png";